import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

/**
 * This guard check if you are an administrator
 */
@Injectable()
export class AdminGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    const user = this.auth.authToken();
    if (user.roles?.includes('ADMIN') || user.groups?.includes('ADMIN')) {
      return true;
    } else {
      this.router.navigate(['/message/notadmin'], {
        queryParams: { url: state.url },
      });
    }
  }
}
